import CircularProgress from '@mui/material/CircularProgress'
import { campaignsSelectors } from 'features/campaigns/slice'
import { useAppSelector } from 'shared/hooks'

export function TableLoader() {
	const isUpdatingTable = useAppSelector(campaignsSelectors.isUpdatingTable)

	if (isUpdatingTable) {
		return (
			<div className='table-material-loader-wrapper'>
				<CircularProgress
					classes={{ colorPrimary: 'material-loader' }}
					color='primary'
					size={60}
				/>
			</div>
		)
	}

	return null
}
